// Shared by the list, the ticket page and the create page, so the three can never
// offer different categories.
export const CATEGORIES = ['SOP', 'System', 'Sales', 'Commission', 'Installation', 'Other'];
export const PRIORITIES = ['Low', 'Normal', 'High'];
export const STATUSES = ['Open', 'In Progress', 'Answered', 'Resolved', 'Closed'];

export const STATUS_COLOR = {
    'Open': ['#FEF3C7', '#92400E'],
    'In Progress': ['#DBEAFE', '#1E40AF'],
    'Answered': ['#E0E7FF', '#3730A3'],
    'Resolved': ['#D1FAE5', '#065F46'],
    'Closed': ['#F1F5F9', '#475569'],
};

export const PP = "'Poppins', sans-serif";

export const fmt = (iso) => iso
    ? new Date(iso).toLocaleString('en-MY', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' })
    : '—';

/** "3h" or "4d" — how long it has been sitting. */
export const age = (hours) => (hours == null ? '—' : hours < 24 ? `${hours}h` : `${Math.floor(hours / 24)}d`);
